import React from 'react';
import Hdr from './shared/Hdr';
import Progress from './Progress';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function Disease() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayDisease, setDisplayDisease] = useState('none');
  const [displayUpdDisease, setDisplayUpdDisease] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [verfied, setVerfied] = useState(true);
  const [id, setID] = useState('');
  //  const [Err, SetErr] = useState([]);
  const handleSubmit = () => {
    verifyDisease()
    if (verfied) {
      formRef.current.reset();
    }
  }
  const formRef = useRef();
  //  const [doctorSpecilation, setDoctorSpecialisation] = useState();
  const [serial, setSerial] = useState('');
  const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [shortDesc, setShortDesc] = useState('');
  const [longDesc, setLongDesc] = useState('');
  const [specialityData, setSpecialityData] = useState([])
  const [updSpecialitiy, setUpdSpeciality] = useState()
  const [defaultSpeciality, setDefaultSpeciality] = useState('1')
  const [isloading, setIsLoading] = useState(false)
  //  const [iconpath, setIconPath] = useState()
  const [updSerial, setUpdSerial] = useState()
  const [updShortDesc, setUpdShortDesc] = useState()
  const [updLongDesc, setUpdLongDesc] = useState()
  const [filteredID, setFilteredId] = useState()

  let txt = "";

  useEffect(() => {
    getDisease(defaultSpeciality)
    getSpeciality()
  }, [])

  function openDisease() {
    setDisplayDisease('block')
  }

  function closeDisease() {
    formRef.current.reset();
    setDisplayDisease('none')
  }

  function openUpdDisease() {
    setDisplayUpdDisease('block')
  }

  function closeUpdDisease() {
    setDisplayUpdDisease('none')
  }

  async function updateDisease(id) {
    //alert(id+','+updSpecialitiy+","+updSerial+", "+updShortDesc+". "+updLongDesc)

    let result = await fetch(apiPath + "updateDisease/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "speciality_id": updSpecialitiy,
        "srl": updSerial,
        "short_desc": updShortDesc,
        "long_desc": updLongDesc
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)
    getDisease(updSpecialitiy)
  }

  async function deleteDisease(id, sp_id) {

    let result = await fetch(apiPath + "deleteDisease/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDisease(filteredID)
  }

  async function updateOperation(id) {
    let result = await fetch(apiPath + "getDisease/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdSpeciality(result.data[0].speciality_id)
    setUpdSerial(result.data[0].srl);
    setUpdShortDesc(result.data[0].short_desc)
    setUpdLongDesc(result.data[0].long_desc)
    setID(result.data[0].id)

    openUpdDisease();
  }


  function deleteOperation(id, sp_id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDisease(id, sp_id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL TESTIMONIALS (for initial screen)*/ 

  async function getDisease(id) {
    let result = await fetch(apiPath + "getDiseaseBySpeciality/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  function verifyDisease() {
    setVerfied(true)
    addDisease()
  }

  //*ADD A NEW Disease*/ 
  async function addDisease() {

    if (verfied) {
      setIsLoading(true)
      let result = await fetch(apiPath + "storeDisease", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "speciality_id": filteredID,
          "srl": serial,
          "icon": "/images/icons-speciality/" + filteredID + "_icon_" + serial + ".png",
          "short_desc": shortDesc,
          "long_desc": longDesc
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)

      getDisease(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  //* LIST OF ALL SPECIALITY (for combo)*/ 

  async function getSpeciality() {
    let result2 = await fetch(apiPath + "specialities",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setSpecialityDataStat(result2.success);
    //  setSpecialityData(result2.data);
    if (result2.success === true) {
      setSpecialityData(result2.data);
    } else { setSpecialityData([]) }
  }

  function FilterData(id) {
    getDisease(id)
    setFilteredId(id)
  }

  {/*
  function SpecialitySelection(val) {
    let str = val
    var parts = str.split(',', 2);
    setDoctorSpecialisation(parts[0])
    setIconPath(parts[1])
  }
*/}

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Disease</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FilterData(e.target.value)}>
                {
                  (specialityDataStat === true ?
                    (
                      specialityData.map((item2, index) =>
                        <option value={item2.id} >{item2.name}</option>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </select>
            </div>
            <div className="c12-l-2">
              <button onClick={openDisease} type="button" name="button"
                className="btn solid round">Add a Disease</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border center" width="5%">Srl</th>
                  <th className="th-border center" width="7%">Icon</th>
                  <th className="th-border left" width="35%">Short Desc</th>
                  <th className="th-border left" width="70%">Long Desc</th>
                  <th className="th-border left" width="7%">Edit</th>
                  <th className="th-border left" width="7%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="center">{item.srl}</td>
                          <td className="center"><img src={`https://adshospital.site${item.icon}`} width={25} height={25} alt=''></img></td>
                          <td className="left">{item.short_desc}</td>
                          <td className="left">{item.long_desc}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW DISEASE */}

          <div id="newdept" style={{ 'display': displayDisease }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDisease}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add a Disease</h2>
                  <br></br>

                  <input type="hidden" value={id} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Serial" onChange={(e) => setSerial(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Short Description" onChange={(e) => setShortDesc(e.target.value)} />


                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Long Description" onChange={(e) => setLongDesc(e.target.value)} />

                  <br></br>
                  <button onClick={handleSubmit} type="button"
                    className="btn solid round">Add Disease</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdDisease }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdDisease}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit FAQ</h2><br /><br />

                  <input type="hidden" value={id} />

                  <select className="custom-select" onChange={(e) => setUpdSpeciality(e.target.value)}
                    value={updSpecialitiy}>
                    {
                      (specialityDataStat === true ?
                        (
                          specialityData.map((item2, index) =>
                            <option value={item2.id} >{item2.name}</option>
                          ))
                        : <tr><td>No data</td></tr>)
                    }
                  </select>

                  <input type="text" className="box small"
                    placeholder="Serial" onChange={(e) => setUpdSerial(e.target.value)}
                    value={updSerial} />

                  <input type="text" className="box small"
                    placeholder="Answer" onChange={(e) => setUpdShortDesc(e.target.value)}
                    value={updShortDesc} />

                  <textarea className="box small" rows='10'
                    placeholder="Answer" onChange={(e) => setUpdLongDesc(e.target.value)}
                    value={updLongDesc} />

                  <br></br>
                  <button onClick={() => { updateDisease(id) }} type="button"
                    className="btn solid round">Update Disease</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Disease;
